import Crud from '../views/CategoriaProduto/Crud'
import Entity from '../views/CategoriaProduto/Add'

let routes = {
    path: '/categoria_produto',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/categoria_produto/add',
            name: 'NewCbo',
            component: Entity
        },
        {
            path: '/categoria_produto/edit/:id?',
            name: 'EditCbo',
            component: Entity
        },
        {
            path: '/categoria_produto',
            name: 'list-categoria-produto',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Categorias de Produtos',
                breadcrumb: [
                    {
                        text: 'Categorias de Produtos',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
